import { Fragment } from "react";

export function NotFoundPage() {
  return (
    <Fragment>
      Not Found Page 404!
    </Fragment>
  );
}